function RenderOrderLists(info) {
	if (!info.order_items) {
		return "";
	}
	let items = info.order_items.map(val => {
		if (!val.brand) {
			val.brand = { name: "N/A" };
		}
		if (!val.product_color) {
			val.product_color = { name: "N/A" };
		}
		if (!val.color) {
			val.color = { name: "N/A" };
		}
		if (!val.model) {
			val.model = { name: "N/A" };
		}
		return `${val.brand_show_id} - ${val.product_color.color_code} - ${val.brand.name} - ${val.product_color.name}<br/>[${
			val.product_color.color_name
		}][${val.model.name}] X ${val.amount}`;
	});
	return items.join("<br/>");
}

function RenderWarehouse(info) {
	if (info.warehouse.name == '寄售仓'){
		return `<span class="el-tag el-tag--danger el-tag--mini">${info.warehouse.name}</span>`;
	}else{
		return info.warehouse.name;
	}
}

function RenderSaler(info) {
	if (info.is_front_order.index == 1) {
		return `<span class="el-tag el-tag--success el-tag--mini">前台</span>`;
	} else if (info.is_front_order.index == 2) {
		return `<span class="el-tag el-tag--warning el-tag--mini">渠道${info.customer.name}</span>`;
	} else {
		return info.saler.name;
	}
}

function RenderPrice(info, type) {
	let price = "";
	if (info.is_special) {
		price = `<span class="text-semi text-danger">${info[type]}</span>`;
	} else {
		price = `<span class="text-semi font-black">${info[type]}</span>`;
	}
	return `<div class="text-right">${price}</div>`;
}

function RateShow(info){
	let rate = ''
	if(info.price_6){
		rate = (info.price_1 / info.price_6).toFixed(2)
	}else {
		rate = 0
	}
	return `<div class="text-right">${rate}</div>`;
}

export { RenderOrderLists, RenderSaler, RenderPrice,RateShow, RenderWarehouse};
